// Fitleasure PDP Gallery Color Filter v8
(function () {
  'use strict';

  function initColorGallery(productInfo) {
    var unique = productInfo.dataset.sectionId;
    var mapEl = document.getElementById('FLColorMediaMap--' + unique);
    if (!mapEl) return;

    var mapData;
    try { mapData = JSON.parse(mapEl.textContent); } catch (e) { return; }

    var rawMap = mapData.mediaColorMap || {};
    var mediaColorMap = {};
    Object.keys(rawMap).forEach(function (key) {
      mediaColorMap[key.split('/').pop()] = rawMap[key];
    });

    var variantColorMap = mapData.variantColorMap || {};
    if (!Object.keys(mediaColorMap).length) return;

    function getNumericId(mediaId) {
      return mediaId ? mediaId.split('-').pop() : null;
    }

    function getColor() {
      var params = new URLSearchParams(window.location.search);
      var vid = params.get('variant');
      if (vid && variantColorMap[vid]) return variantColorMap[vid];
      var input = productInfo.querySelector('input[name="id"]');
      if (input && variantColorMap[input.value]) return variantColorMap[input.value];
      var activeSwatch = productInfo.querySelector('[data-swatch-button].is-active [data-swatch]');
      if (activeSwatch && activeSwatch.dataset.swatch) return activeSwatch.dataset.swatch;
      return null;
    }

    var slider = productInfo.querySelector('[data-product-single-media-slider]');
    var thumbsEl = productInfo.querySelector('[data-product-single-media-thumbs]');
    if (!slider) return;

    // Store all slides and thumbs in original order
    var allSlides = Array.prototype.slice.call(
      slider.querySelectorAll('[data-product-single-media-wrapper]')
    );
    var allThumbs = thumbsEl ? Array.prototype.slice.call(
      thumbsEl.querySelectorAll('.product-single__thumbnail')
    ) : [];

    // Store original parent for re-insertion
    var slideParent = allSlides.length ? allSlides[0].parentNode : slider;

    var currentColor = null;

    function filterGallery(color) {
      if (!color || color === currentColor) return;
      currentColor = color;

      var flkty = null;
      var flktyNav = null;
      try {
        if (window.theme && window.theme.Flickity) {
          flkty = window.theme.Flickity.data(slider);
          if (thumbsEl) flktyNav = window.theme.Flickity.data(thumbsEl);
        }
      } catch (e) {}

      var isMobile = flkty && flkty.isActive;

      if (isMobile) {
        // --- MOBILE: use Flickity remove/append API ---

        // 1. Remove ALL slides from Flickity
        flkty.remove(allSlides);
        if (flktyNav) flktyNav.remove(allThumbs);

        // 2. Re-append only the matching color slides
        var toShow = [];
        var toShowThumbs = [];

        allSlides.forEach(function (slide) {
          var numericId = getNumericId(slide.dataset.mediaId);
          var slideColor = numericId ? mediaColorMap[numericId] : null;
          if (!slideColor || slideColor === color) {
            toShow.push(slide);
          }
        });

        allThumbs.forEach(function (thumb) {
          var thumbId = thumb.dataset.id ? String(thumb.dataset.id) : null;
          var thumbColor = thumbId ? mediaColorMap[thumbId] : null;
          if (!thumbColor || thumbColor === color) {
            toShowThumbs.push(thumb);
          }
        });

        if (toShow.length) {
          flkty.append(toShow);
          flkty.select(0, false, true);
        }
        if (flktyNav && toShowThumbs.length) {
          flktyNav.append(toShowThumbs);
          flktyNav.select(0, false, true);
        }

      } else {
        // --- DESKTOP: show/hide with display ---
        var firstVisibleNumericId = null;

        allSlides.forEach(function (slide) {
          var numericId = getNumericId(slide.dataset.mediaId);
          var slideColor = numericId ? mediaColorMap[numericId] : null;
          var show = !slideColor || slideColor === color;
          slide.style.display = show ? '' : 'none';
          if (show && !firstVisibleNumericId) firstVisibleNumericId = numericId;
        });

        allThumbs.forEach(function (thumb) {
          var thumbId = thumb.dataset.id ? String(thumb.dataset.id) : null;
          var thumbColor = thumbId ? mediaColorMap[thumbId] : null;
          var show = !thumbColor || thumbColor === color;
          thumb.style.display = show ? '' : 'none';
        });

        // Click first visible thumb to navigate
        if (firstVisibleNumericId && thumbsEl) {
          var firstThumb = thumbsEl.querySelector('[data-id="' + firstVisibleNumericId + '"]');
          if (firstThumb) {
            var link = firstThumb.querySelector('a');
            if (link) link.click();
          }
        }
      }
    }

    // Hook into Palo Alto PUB_SUB variantChange
    if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS) {
      window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event || !event.data || !event.data.variant) return;
        var color = variantColorMap[String(event.data.variant.id)];
        if (color) setTimeout(function () { filterGallery(color); }, 80);
      });
    }

    // Initial filter
    var attempts = 0;
    function tryInit() {
      var color = getColor();
      if (!color) return;
      var flkty = null;
      try {
        if (window.theme && window.theme.Flickity) flkty = window.theme.Flickity.data(slider);
      } catch (e) {}
      // On mobile wait for Flickity to be active
      if (!flkty || flkty.isActive) {
        currentColor = null; // reset so filterGallery runs
        filterGallery(color);
      } else if (attempts < 20) {
        attempts++;
        setTimeout(tryInit, 100);
      }
    }
    setTimeout(tryInit, 300);

    // Poll URL for variant changes
    var lastVariant = new URLSearchParams(window.location.search).get('variant');
    setInterval(function () {
      var current = new URLSearchParams(window.location.search).get('variant');
      if (current !== lastVariant) {
        lastVariant = current;
        var color = current ? variantColorMap[current] : null;
        if (color) {
          currentColor = null;
          setTimeout(function () { filterGallery(color); }, 80);
        }
      }
    }, 250);
  }

  function init() {
    document.querySelectorAll('product-info[id^="MainProduct--"]').forEach(initColorGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
